import {
  buildMessage,
  ValidateBy,
  ValidationOptions,
} from "class-validator";

/**
 * Client-side mirror of the server `DateBeforeAttribute`. Validates that this date value is
 * on-or-before the value of another property on the same object. Emitted automatically by the
 * TypeScript exporter for `[DateBefore(nameof(Other))]` C# attributes.
 */
export function DateBefore<T>(property: (keyof T), validationOptions?: ValidationOptions): PropertyDecorator {
  return ValidateBy({
    name: 'dateBefore',
    constraints: [property],
    validator: {
      validate: (value, args) => {
        const object = args?.object as any;
        const comparisonValue = object[property];

        // Skip when either side is missing (matches the server attribute).
        if (value === undefined || value === null || comparisonValue === undefined || comparisonValue === null) {
          return true;
        }

        const current = value instanceof Date ? value.getTime() : new Date(value).getTime();
        const comparison = comparisonValue instanceof Date ? comparisonValue.getTime() : new Date(comparisonValue).getTime();
        if (isNaN(current) || isNaN(comparison)) return true;

        return current <= comparison;
      },
      defaultMessage: buildMessage(
        eachPrefix => eachPrefix + '$property must be before $constraint1',
        validationOptions
      ),
    }
  });
}
